import React from 'react'

import { NavBar } from '../components'
import WipApp from '../_wipComponents/_WipApp'

const NotFound = () => {
  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <div className="container flex-grow-1">
        <div className="row">
          <div className="col-12 p-4">404 Page Not Found</div>
          <WipApp />
        </div>
      </div>
    </div>
  )
}

export default NotFound
